import { enforce } from '../util/abac';
import _isEmpty from 'lodash/isEmpty';
import { evaluatedPolicySelectors } from '../redux/modules/evaluatedPolicy';
import { projectPickerSelectors } from '../redux/modules/projectPicker';
import { projectCohortPickerSelectors } from '../redux/modules/projectCohortPicker';
import { useSelector } from 'react-redux';

type UseEnforceReturnValue = (permission: string) => boolean;

/**
 * Supplies callback to enforce permission based on the project and cohort restriction context
 */
function useEnforce(): UseEnforceReturnValue {
  const policy = useSelector(evaluatedPolicySelectors.selectPolicyForUser);
  const projectId = useSelector(projectPickerSelectors.selectActiveProjectId);
  const cohortId = useSelector(
    projectCohortPickerSelectors.selectActiveProjectCohortId,
  );

  let attributes: any = undefined;
  if (projectId) {
    attributes = {
      resource: {
        dataset: projectId,
        cohorts: ['unspecified'],
        cohortAffinity: true,
      },
    };
  }

  if (cohortId) {
    attributes = {
      resource: {
        ...(attributes?.resource || {}),
        cohorts: [cohortId],
        cohortAffinity: true,
      },
    };
  }

  return (permission: string) => {
    if (!policy || _isEmpty(policy)) return false;

    return enforce(permission, policy, attributes);
  };
}

export default useEnforce;
